module.exports = __webpack_public_path__ + "static/media/gr.0bed56a8.svg";